import classNames from "classnames";
import React from "react";

import { ProgressIcon } from "../customer/progressIcon";

import "./customerRequiredDetailsProgress.scss";

interface OwnProps {
  stage: number;
  maxStages: number;
  reviewStageConfirmed?: boolean;
  inEditMode?: boolean;
}

export class CustomerRequiredDetailsProgress extends React.Component<OwnProps> {

  public createIconAndBar = (i, iconStatus, max) => (
    <div key={i} className="icon-and-bar">
      <div className={classNames("bar", `${iconStatus[i - 1]}`, `stage-${i}`) }/>
      <ProgressIcon
        stageTitle={i === 0 ? <p>Lead Traveller</p> : <p>Traveller<br />{i + 1} of {max}</p>}
        isComplete={iconStatus[i]}
        isPrevComplete={iconStatus[i - 1]}
      />
    </div>)

  public createProgressBar(max, current) {

    const totalIcons = Array.from(Array(max).keys());
    const iconStatus = totalIcons.map((i) => current > i ? true : false);

    if (max > 5) {
      const stage0Mod = current === 0 ? 1 : 0;
      const paymentStageMod = max === current ? 1 : 0;
      return totalIcons.filter(i => i === 0 || i === current + stage0Mod - paymentStageMod || i === max + stage0Mod - paymentStageMod).map((i) =>
        this.createIconAndBar(i, iconStatus, max),
      );
    }

    return totalIcons.map((i) =>
      this.createIconAndBar(i, iconStatus, max),
    );
  }

  public render() {
    const {
      stage,
      maxStages,
      reviewStageConfirmed,
      inEditMode,
    } = this.props;
    const readyForReview = stage === maxStages || inEditMode;

    return (
      <div className="progress-bar">
        {inEditMode ? this.createProgressBar(maxStages, maxStages) : this.createProgressBar(maxStages, stage)}
        <div className="icon-and-bar">
          <div className={classNames("bar", `${readyForReview}`, `stage-${maxStages + 1}`) }/>
          <ProgressIcon stageTitle={<p>Review</p>} isComplete={reviewStageConfirmed} isPrevComplete={readyForReview} />
        </div>
        <div className="icon-and-bar">
          <div className={classNames("bar", `${reviewStageConfirmed}`, "stage-payment") }/>
          <ProgressIcon stageTitle={<p>Payment</p>} isComplete={false} isPrevComplete={reviewStageConfirmed} />
        </div>
        <div className="icon-and-bar">
          <div className={classNames("bar", "false")}/>
        </div>
      </div>
    );
  }
}
